module.exports = __webpack_public_path__ + "img/37.67668d82.png";